/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_See_PlanInputs */

const en_us2_today_see_plan = /** @type {(inputs: Today_See_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View plan`)
};

const pt_br2_today_see_plan = /** @type {(inputs: Today_See_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver plano`)
};

const es_419_today_see_plan = /** @type {(inputs: Today_See_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver plan`)
};

const pt_pt2_today_see_plan = /** @type {(inputs: Today_See_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver plano`)
};

const fr_fr2_today_see_plan = /** @type {(inputs: Today_See_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le programme`)
};

const de_de2_today_see_plan = /** @type {(inputs: Today_See_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan ansehen`)
};

const it_it2_today_see_plan = /** @type {(inputs: Today_See_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi scheda`)
};

/**
* | output |
* | --- |
* | "View plan" |
*
* @param {Today_See_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_see_plan = /** @type {((inputs?: Today_See_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_See_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_see_plan(inputs)
	if (locale === "es-419") return es_419_today_see_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_today_see_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_today_see_plan(inputs)
	if (locale === "de-DE") return de_de2_today_see_plan(inputs)
	if (locale === "it-IT") return it_it2_today_see_plan(inputs)
	return en_us2_today_see_plan(inputs)
});
export { today_see_plan as "today.see_plan" }